'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelLineDetailComponent = exports.parcelLineDetailComponent = {
    template: require('./parcel-line-detail.html'),
    bindings: {
        line: '<',
        showLineState: '<',
        cancel: '&?',
        canCancel: '<?'
    },
    controllerAs: 'vm',
    controller: ["gettextCatalog", "parcelService", function controller(gettextCatalog, parcelService) {
        'ngInject';

        var vm = this;
        vm.stateHistory;

        vm.insuranceDescription = gettextCatalog.getString('parcel.insuranceDescription', { insurancePrice: vm.line.packageType.insurancePrice });
        vm.getLabelUrl = getLabelUrl;
        vm.loadHistory = loadHistory;
        vm.canCancelLine = canCancelLine;
        vm.onCancel = onCancel;

        function loadHistory() {
            if (!vm.stateHistory) {
                parcelService.getStateHistory(vm.line.id).then(function (response) {
                    vm.stateHistory = response.stateHistory;
                });
            }
        }

        function getLabelUrl() {
            return parcelService.getLabelDownloadUrl(vm.line.id);
        }

        function canCancelLine() {
            return vm.canCancel && (vm.line.state.code === 'CREATED' || vm.line.state.code === 'REG');
        }

        function onCancel() {
            vm.cancel();
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-line-detail.js
// module id = 877
// module chunks = 0